import {
  isAdminExternalPath,
  isAdminInternalPath,
} from "@/lib/admin/admin-path";
import {
  isAuthClientType,
  normalizeAuthClientType,
  type AuthClientType,
} from "@/lib/auth/client-type";

export type AuthScope = "admin" | "member";

export const ADMIN_ACCESS_TOKEN_COOKIE = "cms_admin_access_token";
export const ADMIN_REFRESH_TOKEN_COOKIE = "cms_admin_refresh_token";
export const MEMBER_ACCESS_TOKEN_COOKIE = "cms_member_access_token";
export const MEMBER_REFRESH_TOKEN_COOKIE = "cms_member_refresh_token";

/** @deprecated 旧版统一 Cookie，迁移后应清除 */
export const LEGACY_ACCESS_TOKEN_COOKIE = "cms_access_token";
/** @deprecated 旧版统一 Cookie，迁移后应清除 */
export const LEGACY_REFRESH_TOKEN_COOKIE = "cms_refresh_token";

export function getAccessTokenCookieName(scope: AuthScope) {
  return scope === "admin"
    ? ADMIN_ACCESS_TOKEN_COOKIE
    : MEMBER_ACCESS_TOKEN_COOKIE;
}

export function getRefreshTokenCookieName(scope: AuthScope) {
  return scope === "admin"
    ? ADMIN_REFRESH_TOKEN_COOKIE
    : MEMBER_REFRESH_TOKEN_COOKIE;
}

export function resolveAuthScopeFromPathname(pathname: string): AuthScope | null {
  if (isAdminExternalPath(pathname) || isAdminInternalPath(pathname)) {
    return "admin";
  }

  if (pathname.startsWith("/member")) {
    return "member";
  }

  return null;
}

export function parseAuthScope(value: string | null | undefined): AuthScope | null {
  if (value === "admin" || value === "member") {
    return value;
  }

  return null;
}

export function resolveRequestAuthScope(
  request: { headers: { get(name: string): string | null } },
  bodyScope?: string,
): AuthScope {
  const fromBody = parseAuthScope(bodyScope);

  if (fromBody) {
    return fromBody;
  }

  try {
    const pathname = new URL(request.headers.get("referer") ?? "").pathname;
    return resolveAuthScopeFromPathname(pathname) ?? "member";
  } catch {
    return "member";
  }
}

export function encodeSessionClientType(
  clientType: AuthClientType,
  scope: AuthScope,
) {
  return `${clientType}:${scope}`;
}

export function decodeSessionClientType(value: string): {
  clientType: AuthClientType;
  scope: AuthScope;
} {
  const colonIndex = value.lastIndexOf(":");

  if (colonIndex > 0) {
    const clientType = value.slice(0, colonIndex);
    const scope = value.slice(colonIndex + 1);

    if (
      isAuthClientType(clientType) &&
      (scope === "admin" || scope === "member")
    ) {
      return { clientType, scope };
    }
  }

  return {
    clientType: normalizeAuthClientType(value),
    scope: "member",
  };
}
